export const environment = {
  production: false,
  api: {
    http: 'https://api.pp.weezchat.fr/graphql',
    ws: 'wss://api.pp.weezchat.fr/graphql',
  },
};
